import { faFileLines } from '@fortawesome/pro-light-svg-icons/faFileLines';
import { faFiles } from '@fortawesome/pro-light-svg-icons/faFiles';
import { faFolder } from '@fortawesome/pro-light-svg-icons/faFolder';
import { faFolder as faFolderRegular } from '@fortawesome/pro-regular-svg-icons/faFolder';
import { faFolderOpen } from '@fortawesome/pro-light-svg-icons/faFolderOpen';
import { faFolderOpen as faFolderOpenRegular } from '@fortawesome/pro-regular-svg-icons/faFolderOpen';
import { faSidebar } from '@fortawesome/pro-regular-svg-icons/faSidebar';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';

import {
  IconAnimation,
  IconRotation,
  SemanticCategory,
  IconLabel,
} from '../types';

export const SEMANTIC_CATEGORY: SemanticCategory = 'file';
export type SemanticCategoryName = typeof SEMANTIC_CATEGORY;

export const icons = {
  files: faFiles,
  lines: faFileLines,
  'folder-closed': faFolder,
  'folder-closed-active': faFolderRegular,
  'folder-open': faFolderOpen,
  'folder-open-active': faFolderOpenRegular,
  sidebar: faSidebar,
  expand: faCaretRight,
};

export const labels: IconLabel = {
  files: {
    title: (t) => '',
    description: (t) => t('Documents'),
  },
  lines: {
    title: (t) => '',
    description: (t) => t('Document'),
  },
  'folder-closed': {
    title: (t) => '',
    description: (t) => t('Folder'),
  },
  'folder-closed-active': {
    title: (t) => '',
    description: (t) => t('Active Folder'),
  },
  'folder-open': {
    title: (t) => '',
    description: (t) => t('Opened Folder'),
  },
  'folder-open-active': {
    title: (t) => '',
    description: (t) => t('Active Opened Folder'),
  },
  sidebar: {
    title: (t) => '',
    description: (t) => t('Sidebar'),
  },
  expand: {
    title: (t) => '',
    description: (t) => t('Expand'),
  },
};

export type ValidIcons = keyof typeof icons;

export const rotation: IconRotation = {};

export const animation: IconAnimation = {};
